import React from "react";

import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom-v5-compat";

import { ClientId } from "@fartherfinance/frontend/api/Types";

import { TransfersV2Path } from "@src/config/routing/RouterPaths";
import CancelCurrentTriggerModal from "@src/multiCustodian/components/Client/Transfers/CancelCurrentTriggerModal/CancelCurrentTriggerModal";
import FundingSettings from "@src/multiCustodian/pages/Client/:clientId/TransfersV2";

const CancelFundingPlan = (): JSX.Element => {
  const { clientId } = useParams<{
    clientId: ClientId;
  }>();

  const navigate = useNavigate();

  return (
    <FundingSettings>
      <CancelCurrentTriggerModal
        closeModal={() => navigate(`/Client/${clientId}/${TransfersV2Path}`)}
      />
    </FundingSettings>
  );
};

export default CancelFundingPlan;
